// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-navigation {
  z-index: 2;
  position: fixed;
  left: 0;
  right: 70px;
  overflow: hidden;
  top: var(--navbar-height-player-page-mobile);
  bottom: 0;
  pointer-events: none;
  border: none;
}
.right-navigation .ant-drawer:focus-visible {
  outline: none;
}
@media (min-width: 1200px) {
  .right-navigation {
    top: var(--navbar-height-player-page-desktop);
  }
}
@media (min-width: 992px) {
  .right-navigation.clickable-mask-drawer {
    z-index: 0;
  }
}
.right-navigation.isMobile .right-navigation-sidebar {
  transition-delay: 0.35s;
  transition-timing-function: ease-out;
  right: -70px;
  width: 70px;
}
@media (max-width: 767px) {
  .right-navigation.isMobile .right-navigation-sidebar {
    top: unset;
  }
}
.right-navigation.isMobileRightNavOpen .right-navigation-sidebar {
  transition-delay: 0s;
  right: 0;
}
@media (min-width: 992px) {
  .right-navigation {
    right: 80px;
  }
}
.right-navigation .right-navigation-sidebar {
  position: fixed;
  background-color: #3a3a3a;
  right: 0;
  width: 70px;
  top: var(--navbar-height-player-page-mobile);
  height: calc(100vh - var(--navbar-height-player-page-mobile));
  z-index: 9999;
  pointer-events: initial;
  transition: right 0.2s linear;
}
@media (min-width: 992px) {
  .right-navigation .right-navigation-sidebar {
    width: 80px;
  }
}
@media (min-width: 1200px) {
  .right-navigation .right-navigation-sidebar {
    top: var(--navbar-height-player-page-desktop);
    height: calc(100vh - var(--navbar-height-player-page-desktop));
  }
}
.right-navigation .right-navigation-sidebar__scrollable-container {
  max-height: 100%;
  position: relative;
  overflow: auto;
}
.right-navigation .right-navigation-sidebar__items-container {
  display: flex;
  flex-direction: column;
  padding-bottom: 110px;
}
.right-navigation .polling-iframe {
  width: 100%;
  min-height: calc(100vh - 8rem);
  border: none;
}
.right-navigation .item {
  text-align: center;
  height: 5rem;
  display: flex;
  justify-content: center;
  background-color: var(--right-navigation-bg-color);
  cursor: pointer;
}
.right-navigation .item .anticon {
  font-size: 2.2rem;
  color: #fff;
}
.right-navigation .item.active {
  background-color: #fff;
}
.right-navigation .item.active .anticon {
  color: #3a3a3a;
}
.right-navigation .item:hover {
  background-color: #fff;
}
.right-navigation .item:hover .anticon {
  color: #3a3a3a;
}
.right-navigation .ant-drawer-content-wrapper {
  box-shadow: none;
}
.right-navigation .ant-drawer .ant-drawer-title {
  color: var(--drawer-section-title-color);
}
.right-navigation .ant-drawer .ant-drawer-content-wrapper {
  background-color: var(--drawer-contents-bg-color);
}
.right-navigation .ant-drawer .ant-drawer-content-wrapper .ant-drawer-content {
  background-color: var(--drawer-contents-bg-color);
}
.right-navigation .ant-drawer .ant-drawer-content-wrapper .rn-drawer-agenda {
  background-color: var(--agenda-drawer-bg-color);
}
.right-navigation .ant-drawer .ant-drawer-content-wrapper .rn-drawer-qa {
  background-color: var(--qa-form-drawer-bg-color);
}
.right-navigation .ant-drawer .ant-drawer-content-wrapper .rn-drawer-info {
  color: var(--info-drawer-text-color);
}
.right-navigation .ant-drawer-mask {
  background: transparent !important;
}
.right-navigation--countdown-active .right-navigation-sidebar__items-container > *:not(.right-navigation-sidebar-logout-button, .right-navigation-sidebar-contacts-button) {
  display: none;
}
@media (min-width: 992px) {
  .right-navigation--countdown-active {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/RightNavigation/RightNavigation.scss"],"names":[],"mappings":"AAOA;EACI,UAAA;EACA,eAAA;EACA,OAAA;EACA,WAPmB;EAQnB,gBAAA;EACA,4CAAA;EACA,SAAA;EACA,oBAAA;EACA,YAAA;AANJ;AAQI;EACI,aAAA;AANR;AASI;EAfJ;IAgBQ,6CAAA;EANN;AACF;AASQ;EADJ;IAEQ,UAAA;EANV;AACF;AAUQ;EACI,uBAAA;EACA,oCAAA;EACA,YAAA;EACA,WAjCW;AAyBvB;AAUY;EANJ;IAOQ,UAAA;EAPd;AACF;AAYQ;EACI,oBAAA;EACA,QAAA;AAVZ;AAcI;EA7CJ;IA8CQ,WAhDgB;EAqCtB;AACF;AAaI;EACI,eAAA;EACA,yBAAA;EACA,QAAA;EACA,WAxDe;EAyDf,4CAAA;EACA,6DAAA;EACA,aAAA;EACA,uBAAA;EACA,6BAAA;AAXR;AAaQ;EAXJ;IAYQ,WA/DY;EAqDtB;AACF;AAYQ;EAfJ;IAgBQ,6CAAA;IACA,8DAAA;EATV;AACF;AAWQ;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;AATZ;AAYQ;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;AAVZ;AAcI;EACI,WAAA;EACA,8BAAA;EACA,YAAA;AAZR;AAeI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kDAAA;EACA,eAAA;AAbR;AAeQ;EACI,iBAAA;EACA,WAAA;AAbZ;AAgBQ;EACI,sBAAA;AAdZ;AAgBY;EACI,cAAA;AAdhB;AAkBQ;EACI,sBAAA;AAhBZ;AAkBY;EACI,cAAA;AAhBhB;AAqBI;EACI,gBAAA;AAnBR;AAwBQ;EACI,wCAAA;AAtBZ;AAyBQ;EACI,iDAAA;AAvBZ;AAyBY;EACI,iDAAA;AAvBhB;AA2BgB;EACI,+CAAA;AAzBpB;AA4BgB;EACI,gDAAA;AA1BpB;AA6BgB;EACI,oCAAA;AA3BpB;AAkCI;EACI,kCAAA;AAhCR;AAqCY;EACI,aAAA;AAnChB;AAuCQ;EAPJ;IAQQ,aAAA;EApCV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
